import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

import { isEqual as _isEqual } from 'lodash';
import lottie from 'lottie-web'; // eslint-disable-line import/no-unresolved
import PropTypes from 'prop-types';

class Animation extends PureComponent {
  componentDidMount() {
    this.loadAnimation(this.props);

    this.playSegmants();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.source && nextProps.source && this.props.source.nm !== nextProps.source.nm) {
      this.loadAnimation(nextProps);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_isEqual(this.props.currentSegmants, prevProps.currentSegmants)) {
      this.playSegmants();
    }
  }

  animationDOMNode = null;

  playSegmants = () => {
    const { currentSegmants } = this.props;
    if (currentSegmants) {
      this.play(currentSegmants);
    }
  };

  loadAnimation = props => {
    if (this.anim) {
      this.anim.destroy();
    }

    this.anim = lottie.loadAnimation({
      container: this.animationDOMNode,
      animationData: props.source,
      renderer: 'svg',
      loop: props.loop || false,
      autoplay: props.autoPlay,
      rendererSettings: props.rendererSettings || {},
    });
  };

  setAnimationDOMNode = ref => (this.animationDOMNode = ReactDOM.findDOMNode(ref));

  play = (...frames) => {
    if (!this.anim) {
      return;
    }

    this.anim.playSegments(frames, true);
  };

  reset = () => {
    if (!this.anim) {
      return;
    }

    this.anim.stop();
  };

  render() {
    return <div style={this.props.style} ref={this.setAnimationDOMNode} />;
  }
}

Animation.propTypes = {
  currentSegmants: PropTypes.array || PropTypes.arrayOf(Array),
  source: PropTypes.any,
  style: PropTypes.any,
};

export default React.forwardRef((props, ref) => (
  <Animation {...props} ref={typeof ref === 'function' ? c => ref(c && c.anim) : ref} />
));
